// Import the functions you need from the SDKs you need
//https://blog.logrocket.com/user-authentication-firebase-react-apps/
import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signOut } from "firebase/auth";
import { loginGoogle } from "routes/Login/services/api/Auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

//google auth ptoject project-226987858608

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB7EWqbtP-nTFib111i-MrYyGZ9LzsjOi8",
    authDomain: "inteliqr-52944.firebaseapp.com",
    projectId: "inteliqr-52944",
    storageBucket: "inteliqr-52944.appspot.com",
    messagingSenderId: "226987858608",
    appId: "1:226987858608:web:ed334422d40f0a2c603975"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

const signInWithGoogle = async () => {
    try {
        const res = await signInWithPopup(auth, googleProvider)
        const usr = res.user
        console.log(usr)
    } catch (error) {
        console.error(error);
    }
}

const logout = () => {
    console.log("logout")
    signOut(auth);
};

export {
    auth,
    signInWithGoogle,
    logout,
};